import BaseService from "../core/BaseService";

export default class UsersService extends BaseService {

  static async list(clientId: string, query: string, disabled: string, page: number, pageSize: number) {
    return await super.request(`/users?cid=${clientId}&disabled=${disabled}&q=${query ? encodeURIComponent(query) : ''}&limit=${pageSize}&skip=${pageSize * (page - 1)}`);
  }

  static async get(userId: string) {
    return await super.request(`/users/${userId}`);
  }

  static async update(userId: string, data: any) {
    return await super.request(`/users/${userId}`, 'PUT', data);
  }

  static async create(data: any) {
    return await super.request(`/users`, 'POST', data);
  }

  static async enableDisable(userId: number, disable: boolean) {
    return await super.request(`/users/${userId}/${disable ? 'disable' : 'enable'}`, 'PUT');
  }

  static async delete(userId: number) {
    return await super.request(`/users/${userId}`, 'DELETE');
  }
}